<template>
    <div id="gl3" class="glide highlights-menu">
        <div data-glide-el="track" class="glide__track">
            <ul class="glide__slides">
                <li v-for="slide in menu" :key="slide.title" class="glide__slide">
                    <router-link :to="{name: slide.name, params: {provider: (slide.params ? slide.params.provider : ''), game: (slide.params ? slide.params.gameId : '')}}">
                        <div class="glide__inner">
                            <div class="highlights-menu__text">{{`components.common.highlights-menu.${slide.title}` | translate}}</div>
                        </div>
                        <img class="highlights-menu__image" :src="`/static/mbk/highlights-menu/${slide.title}.png`" :alt="slide.title">
                    </router-link>
                </li>
            </ul>
        </div>
        <div v-if="!isMobilePhone && slidesCount > 1" data-glide-el="controls[nav]" class="glide__controls">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<"></button>
            <div class="glide__bullets" data-glide-el="controls[nav]">
                <button v-for="i in slidesCount" :key="i" class="glide__bullet" :data-glide-dir="`=${i-1}`"></button>
            </div>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">"></button>
        </div>
    </div>
</template>
<script>
import Glide from '@glidejs/glide';
import isMobile from 'ismobilejs';

export default {
    name: 'highlights-menu',
    data() {
        return {
            glide: null,
            menu: [
                {
                    title: 'casino',
                    name: 'slots',
                },
                {
                    title: 'crash',
                    name: 'crash',
                },
                {
                    title: 'keno',
                    name: 'fast',
                },
                {
                    title: 'races',
                    name: 'races',
                },
                {
                    title: 'spin2win',
                    name: 'game',
                    params: {
                        provider: 'flg',
                        gameId: '248'
                    }
                },
            ]
        };
    },
    computed: {
        isDotsShown() {
            return this.glide && this.glide.settings.perView > 2
        },
        slidesCount() {
            return this.menu.length;
        },
        isMobilePhone() {
            return isMobile.phone;
        }
    },
    mounted() {
        this.glide = new Glide('#gl3', {
            type: 'carousel',
            perView: 4,
            rewind: true,
            autoplay: 4000,
            gap: 24,
            sizes: true,
            breakpoints: {
                1191: {
                    perView: 3,
                    gap: 12
                },
                470: {
                    perView: 2,
                    gap: 5
                }
            }
        });
        console.log(this.glide);
        this.glide.mount();
    }
}
</script>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/highlights-menu/highlights-menu.vue